import { format, formatISO } from "date-fns";

import { CompanyFeedbackFilter } from "./components/CompanyFeedbackFilters";

import { CompanyFeedbackCsvQueryParams } from "../../api/services";
import { CompanyFeedbackStreamFilters } from "../../api/services/defs/internal-api/feedback";

export const getFiltersForSearch = (
	searchTerm: string,
	additionalFilters: CompanyFeedbackFilter,
	customFieldRefIds?: string[]
) => {
	const filters: any = {};
	if (additionalFilters?.author) {
		filters.author_id_eq = additionalFilters?.author?.value;
	}

	if (additionalFilters?.subject) {
		filters.subject_ids_in = [additionalFilters?.subject.value];
	}

	if (additionalFilters?.sharedWith?.value) {
		filters.shared_with_in = [additionalFilters?.sharedWith?.value];
	}

	if (additionalFilters?.responseToRequest) {
		filters.response_to_request_eq = additionalFilters?.responseToRequest.value === "true";
	}

	if (additionalFilters?.hashTags) {
		filters.categories_in = additionalFilters?.hashTags.map((hashTag) => hashTag.value);
	}

	if (additionalFilters?.dateAfter) {
		filters.last_updated_gt = formatISO(additionalFilters?.dateAfter);
	}

	if (additionalFilters?.dateBefore) {
		filters.last_updated_lt = formatISO(additionalFilters.dateBefore);
	}

	if (searchTerm) {
		filters["author.name_re"] = searchTerm;
		filters["subject.name_re"] = searchTerm;
		filters["content_re"] = searchTerm;
	}

	if (customFieldRefIds && customFieldRefIds.length > 0) {
		filters.custom_field_ids_in = customFieldRefIds;
	}

	return filters;
};

export const getFiltersForStream = (
	searchTerm: string,
	enabledCustomFieldRefIds: string[],
	filters: Partial<CompanyFeedbackFilter>
): CompanyFeedbackStreamFilters => {
	const f: CompanyFeedbackStreamFilters = {};
	if (filters?.author) f.authorId = filters.author.value;
	if (filters?.subject) f.subjectId = filters.subject.value;
	if (filters?.sharedWith?.value) f.sharedWith = filters.sharedWith.value;
	if (filters?.hashTags?.length) f.categories = filters.hashTags.map((h) => h.value).filter((v): v is string => !!v);
	if (filters?.dateAfter) f.dateAfter = filters.dateAfter.toISOString();
	if (filters?.dateBefore) f.dateBefore = filters.dateBefore.toISOString();
	if (filters?.responseToRequest) f.responseToRequest = filters.responseToRequest.value === "true";
	if (searchTerm) f.searchTerm = searchTerm;
	if (enabledCustomFieldRefIds.length) f.customFieldIds = enabledCustomFieldRefIds;
	return f;
};

export const getQueryParamsForCsvDownload = (additionalFilters: CompanyFeedbackFilter, pageNumber: number) => {
	const queryParams: Partial<CompanyFeedbackCsvQueryParams> = {};

	if (additionalFilters?.author) {
		queryParams.author = additionalFilters.author?.value;
	}

	if (additionalFilters?.subject) {
		queryParams.subject = additionalFilters.subject?.value;
	}

	if (additionalFilters?.sharedWith?.value) {
		queryParams.shared_with = "option-" + additionalFilters?.sharedWith?.value;
	}

	if (additionalFilters?.hashTags) {
		queryParams.categories = additionalFilters?.hashTags
			.filter((hashTag) => hashTag.value !== undefined)
			.map((hashTag) => hashTag.value as string);
	}

	if (additionalFilters?.dateAfter) {
		queryParams.complete_date_start = format(additionalFilters.dateAfter, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");
	}

	if (additionalFilters?.dateBefore) {
		queryParams.complete_date_end = format(additionalFilters.dateBefore, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");
	}

	queryParams.page = pageNumber.toString();

	return queryParams;
};

export const isReferenceTypeCustomField = (customField: any) => {
	return customField.type === "person" || customField.type === "people" || customField.type === "department";
};
